import styles from './JobMailWrapper.less';

import React, { Component } from 'react';
import JobMail from './JobMail';
import { MailIcon } from 'seek-style-guide/react';

class JobMailWrapper extends Component {
  render() {
    return (
      <section className={styles.root} data-automation="savePanel">
        <h1 className={styles.savePrompt}><MailIcon className={styles.icon} /> Receive new jobs for this search by email</h1>
        <JobMail />
      </section>
    );
  }
}

export default JobMailWrapper;



/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/components/SavePanel/components/JobMail/JobMailWrapper.js
 **/